exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-certificate[data-v-14a4b798] {\n  border: 1px solid #ebf1fa;\n  border-radius: 4px;\n}\n.image-upload-box[data-v-14a4b798] {\n  padding: 0;\n  height: 70px;\n}\n", ""]);

// exports
